const steps = [
  {
    num: "01",
    title: "Discover",
    desc: "We begin with a deep understanding of your financial goals, background, and aspirations through a structured discovery conversation.",
  },
  {
    num: "02",
    title: "Educate",
    desc: "Through our academy and resources, we build your financial literacy and investor readiness with structured, practical learning pathways.",
  },
  {
    num: "03",
    title: "Strategize",
    desc: "Our advisory team crafts a personalized cross-border investment strategy aligned with your timeline, risk profile, and wealth-building objectives.",
  },
  {
    num: "04",
    title: "Connect",
    desc: "We connect you to our curated network of partners, opportunities, and capital relationships across Africa and the global diaspora.",
  },
];

export default function HowWeWorkSection() {
  return (
    <section className="py-24 px-6 bg-[#F8F6F3]">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-3">
            Our Approach
          </span>
          <h2 className="font-['Cormorant_Garamond'] text-4xl md:text-5xl font-bold text-[#2B2D2F]">
            How We Work
          </h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {/* Connecting line (desktop) */}
          <div className="hidden lg:block absolute top-10 left-[12.5%] right-[12.5%] h-px bg-[#C9A961]/30" />

          {steps.map((step, i) => (
            <div key={step.num} className="relative flex flex-col items-center text-center">
              {/* Number circle */}
              <div className="relative z-10 w-20 h-20 flex items-center justify-center rounded-full bg-white border-2 border-[#C9A961] mb-6">
                <span className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#C9A961]">{step.num}</span>
              </div>
              <h3 className="font-['Cormorant_Garamond'] text-2xl font-bold text-[#2B2D2F] mb-3">{step.title}</h3>
              <p className="text-[#6B6B6B] text-sm leading-relaxed font-['Inter']">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
